import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from '../../Generic/Typography';
import cardStyles from './VideoCard-tw-styles';
import getWidth from '../../../utils/gridWidth';
import { Button } from '../../Generic/Button';
import i18nMessages from '../../../constants/messages/pt-BR';
import { getCdnImage } from "../../../utils/ImageManager"
import DOMPurify from 'isomorphic-dompurify';

class VideoCard extends React.Component {
  state = {
    showVideo: false,
    isMobile: false,
  };
  componentDidMount() {
    window.addEventListener(i18nMessages.scroll, this.scrollVideoHandler);
    window.addEventListener(i18nMessages.resize, this.handleWindowChange);
    this.handleWindowChange();
    this.scrollVideoHandler();
  }
  componentWillUnmount() {
    window.removeEventListener(i18nMessages.scroll, this.scrollVideoHandler);
    window.removeEventListener(i18nMessages.resize, this.handleWindowChange);
  }
  handleWindowChange = () => {
    const isMobile = window.innerWidth < 767;
    this.setState({
      isMobile: isMobile,
    });
  };
  onClickHandler = () => {
    this.setState({ showVideo: true });
  };
  scrollVideoHandler = () => {
    const { data } = this.props;
    if (document.getElementById(data.sys.id)) {
      const videoDiv = document.getElementById(data.sys.id);
      // Get it's position in the viewport
      const iframes =
        videoDiv &&
        videoDiv.getElementsByTagName(i18nMessages.iframe)[0].contentWindow;
      if (
        !(
          window.scrollY < videoDiv.offsetTop + videoDiv.offsetHeight &&
          window.scrollY + window.outerHeight > videoDiv.offsetTop
        )
      ) {
        iframes &&
          iframes.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
      }
    }
  };

  render() {
    const { cardType = i18nMessages.VideoCard, data ,heroImage} = this.props;

    const { showVideo, isMobile } = this.state;
    let cardTypestyle = (data.styles && data.styles.trim()) || cardType;
    if (cardStyles[cardTypestyle] === undefined) {
      cardTypestyle = cardType;
    }
    if (cardStyles[cardTypestyle].card === undefined) {
      cardStyles[cardTypestyle] = i18nMessages.VideoCard;
    }

    const widthClass = getWidth(data.componentWidth);
    const videoData = data.video;
    const autoPlayVideo = videoData.autoplay ? 1 : 0;
    return (
      <div className={classNames(widthClass, cardStyles[cardTypestyle].card)}>
        {!showVideo && (
          <div className={classNames(cardStyles[cardTypestyle].mediaWrapper)}>
            {isMobile &&
            videoData.videoMobileThumbnail &&
            videoData.videoMobileThumbnail.url
              ? videoData.videoMobileThumbnail &&
                videoData.videoMobileThumbnail.url && (
                  <img
                    className={classNames(
                      cardStyles[cardTypestyle].thumbnailImage
                    )}
                    alt={heroImage?.description ? heroImage?.description :"img"}
                    src={getCdnImage(videoData.videoMobileThumbnail.url)}
                  />
                )
              : videoData.videoThumbnail &&
                videoData.videoThumbnail.url && (
                  <img
                    className={classNames(
                      cardStyles[cardTypestyle].thumbnailImage
                    )}
                    alt={heroImage?.description ? heroImage?.description :"img"}
                    src={getCdnImage(videoData.videoThumbnail.url)}
                  />
                )}
            <div className={classNames(cardStyles[cardTypestyle].cardContent)}>
              {data.title && (
                <Typography
                  className={classNames(cardStyles[cardTypestyle].header)}
                  component="h2"
                  dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.title),
                  }}
                />
              )}
              {data.text && (
                <Typography
                  className={classNames(cardStyles[cardTypestyle]?.description)}
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( data.text),
                  }}
                />
              )}
            </div>
            {data.callToActionsCollection && (
              <div
                className={classNames(cardStyles[cardTypestyle].cardActions)}
              >
                {data.callToActionsCollection.items.map(item => {
                  if (item.__typename === i18nMessages.ImageButton) {
                    return (
                      <>
                        {isMobile &&
                        item.imageMobile &&
                        item.imageMobile.url ? (
                          <div
                            className={
                              cardStyles[cardTypestyle].buttonContainer
                            }
                          >
                            <Button
                              onClick={this.onClickHandler}
                              data-action-detail="video-play"
                              className="event_video_play"
                            >
                              <img
                                className={classNames(
                                  cardStyles[cardTypestyle].playButton
                                )}
                                id={i18nMessages.mobile}
                                alt={item.alt ? item.alt : 'play button'}
                                src={getCdnImage(item.imageMobile.url)}
                              />
                            </Button>
                          </div>
                        ) : (
                          <div
                            className={
                              cardStyles[cardTypestyle].buttonContainer
                            }
                          >
                            <Button
                              onClick={this.onClickHandler}
                              data-action-detail="video-play"
                              className="event_video_play"
                            >
                              <img
                                className={classNames(
                                  cardStyles[cardTypestyle].playButton
                                )}
                                id={i18nMessages.desk}
                                alt={item.alt ? item.alt : 'play button'}
                                src={getCdnImage(item.image && item.image.url)}
                              />
                            </Button>
                          </div>
                        )}
                      </>
                    );
                  }
                })}
              </div>
            )}
          </div>
        )}

        {showVideo && (
          <div
            className={classNames(
              cardStyles[cardTypestyle].videoWrapper,
              'w-full'
            )}
            id={`${data.sys.id}`}
          >
            <div className={classNames(cardStyles.videoWrapper)}>
              <iframe
                title="video"
                className={`${data.sys.id}`}
                src={`${videoData.videoLink}?rel=0&amp;autoplay=${autoPlayVideo}&enablejsapi=1`}
                style={{
                  width: '100%',
                  height: '100%',
                }}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
VideoCard.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  cardType: PropTypes.string,
};
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const VideoCard = ({prop = val, data = null, cardType = 'VideoCard' }) =>
export default VideoCard;
